import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconSearch from '@material-ui/icons/Search';

export default function TableWithSearch({ children, filter, onSearch }) {
  return (
    <>
      <Input
        fullWidth={true}
        placeholder="Search..."
        value={filter}
        onChange={(event) => onSearch(event.currentTarget.value)}
        style={{ marginTop: 10, marginBottom: 30 }}
        startAdornment={
          <InputAdornment position="start">
            <IconSearch />
          </InputAdornment>
        }
      />

      {/* 72px is the height of the Input (32px) + the 40px margin */}
      <TableContainer style={{ height: 'calc(100vh - 72px)' }}>
        <Table padding="none" stickyHeader>{children}</Table>
      </TableContainer>
    </>
  );
}
